import { Button } from "@studyplus/boron-ui";
import { ErrorMessage, Field, Form, FormikProps } from "formik";
import { SyntheticEvent } from "react";
import Input from "../../../../../components/atoms/Input";
import Label from "../../../../../components/atoms/Label";
import styles from "../styles.scss";

type Values = {
  csv: Blob | undefined;
};

export const InnerForm = (props: FormikProps<Values>) => {
  const handleChangeFile =
    (fieldName: string) => (e: SyntheticEvent<HTMLInputElement>) => {
      const { setFieldTouched, setFieldValue, setFieldError } = props;
      if (e.currentTarget && e.currentTarget.files) {
        setFieldValue(fieldName, e.currentTarget.files[0]);
        setFieldTouched(fieldName, true, false);
        setFieldError(fieldName, undefined);
      } else {
        setFieldValue(fieldName, undefined);
        setFieldTouched(fieldName, true, false);
      }
    };

  return (
    <Form className="flex flex-wrap items-end justify-between w-full w-[calc(100%+2rem)] -mt-8 -ml-8">
      <div className="flex-1 basis-3/4 mt-8 ml-8">
        <Label className="my-4 mb-2.5 " htmlFor="csv">
          CSVファイル
        </Label>
        <Field
          id="csv"
          component={Input}
          name="csv"
          type="file"
          accept=".csv,text/csv"
          onChange={handleChangeFile("csv")}
        />
        <ErrorMessage name="csv">
          {(msg) => <div className={styles.errorMessage}>{msg}</div>}
        </ErrorMessage>
      </div>
      <div className="flex-1 basis-1/5 mt-8 ml-8">
        <Button
          disabled={!props.isValid || props.isSubmitting}
          isBlock={true}
          type="submit"
        >
          インポート
        </Button>
      </div>
    </Form>
  );
};
